import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { RecertFormData } from 'components/Assessments/RecertAssessment/types/RecertFormData'
import { RecertFormField } from 'components/Assessments/RecertAssessment/types/RecertFormField'
import { RecertAssessmentQuestionnaireItem } from 'components/Assessments/RecertAssessment/types/questionnaire'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'

/**
 * Cardiac subsection adapter
 * Handles cardiovascular assessment and heart sounds (4 fields)
 */
export class CardiacAdapter extends BaseSubsectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Cardiac assessment fields
    const cardiacStatus = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL
    )?.at(0)

    const cardiacAbnormalFactors = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS
    )

    const heartSounds = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS
    )?.at(0)

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [RecertFormField.CARDIAC_STATUS]: cardiacStatus,
      [RecertFormField.CARDIAC_ABNORMAL_FACTORS]: cardiacAbnormalFactors,
      [RecertFormField.CARDIAC_HEART_SOUNDS]: heartSounds,
      [RecertFormField.CARDIAC_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RecertFormField.CARDIAC_STATUS)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL,
        value: this.getFormDataField(RecertFormField.CARDIAC_STATUS)
      })
    }

    if (this.formDataFieldExists(RecertFormField.CARDIAC_ABNORMAL_FACTORS)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS,
        value: this.getFormDataField(RecertFormField.CARDIAC_ABNORMAL_FACTORS)
      })
    }

    if (this.formDataFieldExists(RecertFormField.CARDIAC_HEART_SOUNDS)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS,
        value: this.getFormDataField(RecertFormField.CARDIAC_HEART_SOUNDS)
      })
    }

    if (this.formDataFieldExists(RecertFormField.CARDIAC_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY,
        value: this.getFormDataField(RecertFormField.CARDIAC_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
